import React from 'react';
import { colors } from 'styleguide';

interface Props {
  width?: number;
  height?: number;
  color?: {
    primary: string;
    secondary: string;
  };
}

const GridColumns = ({
  width = 64,
  color = { primary: colors('neutral', 2), secondary: colors('neutral', 3) },
}: Props) => (
  <svg width={width} viewBox="0 0 64 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="29.5"
      y="0.5"
      width="43"
      height="29"
      rx="1.5"
      transform="rotate(90 29.5 0.5)"
      stroke={color.primary}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4"
    />
    <rect
      x="63.5"
      y="0.5"
      width="43"
      height="29"
      rx="1.5"
      transform="rotate(90 63.5 0.5)"
      stroke={color.primary}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4"
    />
  </svg>
);

export default GridColumns;
